import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { twMerge } from "tailwind-merge";
import MobileCarInfoV2 from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/MobileCarInfoV2";
import PaymentInfo from "@/pages/checkout/components/PaymentInfo/PaymentInfo";
import AmwalInfoComponent from "@/pages/checkout/bnpl/amwal/components/AmwalInfoComponent";
import AmwalOTPStep from "@/pages/checkout/bnpl/amwal/components/AmwalOTPStep";
import { handleHasAccountEvent } from "@/utils/common";
import { useLang } from "@/common/Contexts/LanguageContext";
import { api__createAmwalCheckoutSession, AmwalValidationError } from "@/pages/checkout/bnpl/amwal/api/amwalApi";
import { serverUrl } from "@globalConfig";
import { useAmwalFinance } from "@/common/Contexts/AmwalFinanceContext";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import { toast } from "sonner";
import WarrantySection from "@/pages/checkout/warranty/WarrantySection";
var AmwalFormContent = function AmwalFormContent(_ref) {
  var checkoutOrder = _ref.checkoutOrder,
    fetch_loading = _ref.fetch_loading,
    userInfo = _ref.userInfo,
    isOtpStep = _ref.isOtpStep,
    autosend = _ref.autosend,
    setIsOtpStep = _ref.setIsOtpStep,
    setAutoSend = _ref.setAutoSend,
    onInfoIconClick = _ref.onInfoIconClick,
    _ref$showCancelButton = _ref.showCancelButton,
    showCancelButton = _ref$showCancelButton === void 0 ? false : _ref$showCancelButton,
    onCancelButtonClick = _ref.onCancelButtonClick,
    onFormUpdated = _ref.onFormUpdated,
    onFormCompleted = _ref.onFormCompleted;
  var _useTranslation = useTranslation(["web_checkout_finance", "web_checkout_cash", "web_sell_trade"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var lang = useLang();
  var _useAmwalFinance = useAmwalFinance(),
    amwalActions = _useAmwalFinance.actions,
    remote_actions = _useAmwalFinance.remote_actions;
  var isDesktop = !isMobile;
  var handleOtpVerified = function handleOtpVerified(userData) {
    if (!isLoggedIn) {
      handleHasAccountEvent({
        hasAccount: userData.has_account,
        status: "Success",
        phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
        lang: lang,
        referral_location: "amwal_order"
      });
    }
    var post_id = (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_id) || 0;
    var selectedCity = String(userInfo.city_id || "1");
    var amwalRequest = {
      post_id: post_id,
      first_name: (userInfo.first_name || "").trim(),
      last_name: (userInfo.family_name || "").trim(),
      phone_number: userInfo.mobile_number || "",
      city_id: parseInt(selectedCity),
      whatsapp_optin: userInfo.whatsapp_optin,
      success_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-amwal/payment-status?post_id=").concat(post_id),
      failure_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-amwal/payment-status?post_id=").concat(post_id),
      cancel_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-amwal/payment-status?post_id=").concat(post_id)
    };
    api__createAmwalCheckoutSession(amwalRequest).then(function (response) {
      var _response$data;
      if (response.success && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.checkout_url) {
        var _response$data2, _response$data3, _checkoutOrder$g4_dat, _checkoutOrder$g4_dat2, _checkoutOrder$g4_dat3, _checkoutOrder$g4_dat4, _checkoutOrder$g4_dat5, _checkoutOrder$g4_dat6, _checkoutOrder$g4_dat7;
        amwalActions === null || amwalActions === void 0 ? void 0 : amwalActions.action__updateUserInfo({
          first_name: userInfo.first_name,
          family_name: userInfo.family_name,
          mobile_number: userInfo.mobile_number,
          city_id: selectedCity,
          city_name: userInfo.city_name || null,
          whatsapp_optin: userInfo.whatsapp_optin,
          order_id: String(((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.order_id) || "")
        });
        trackEvents("amwal_form_submit", {
          post_id: post_id,
          order_id: String(((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.order_id) || ""),
          user_city: userInfo.city_name || selectedCity,
          inventory_type: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat === void 0 ? void 0 : _checkoutOrder$g4_dat.inventory_type,
          post_make: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat2 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat2 === void 0 ? void 0 : _checkoutOrder$g4_dat2.post_make,
          post_model: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat3 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat3 === void 0 ? void 0 : _checkoutOrder$g4_dat3.post_model,
          post_trim: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat4 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat4 === void 0 ? void 0 : _checkoutOrder$g4_dat4.post_ext,
          post_year: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat5 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat5 === void 0 ? void 0 : _checkoutOrder$g4_dat5.post_year,
          post_condition: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat6 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat6 === void 0 ? void 0 : _checkoutOrder$g4_dat6.post_condition,
          post_price: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat7 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat7 === void 0 ? void 0 : _checkoutOrder$g4_dat7.post_price,
          total_amount: checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.total_price ? parseFloat(checkoutOrder.total_price.replace(/,/g, "")) : undefined,
          platform: getPlatformInfo(),
          referral_location: "pre-checkout"
        });
        onFormCompleted === null || onFormCompleted === void 0 ? void 0 : onFormCompleted();
        window.location.href = response.data.checkout_url;
      } else {
        setIsOtpStep(false);
        toast.error(tShort("tamara/payment_session_error"));
      }
    })["catch"](function (error) {
      setIsOtpStep(false);
      console.error("Error creating Amwal checkout after OTP:", error);
      if (error instanceof AmwalValidationError) {
        error.validationErrors.forEach(function (errorObj) {
          Object.values(errorObj).forEach(function (message) {
            toast.error(message);
          });
        });
      } else {
        toast.error(tShort("tamara/connection_error"));
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-auto !w-[80%] max-w-[1152px] max-lg:!w-[90%] after:content-[''] after:fixed after:bottom-0 after:left-0 after:w-full after:h-full after:z-[-1] after:bg-[#ffffff] sm:after:bg-[#fafcff] !mt-0 md:!mt-8 relative"
  }, showCancelButton && onCancelButtonClick && /*#__PURE__*/React.createElement("button", {
    className: "whtBtn w-[76px] h-8 flex items-center justify-center rounded border border-[#d6dfe9] cursor-pointer",
    onClick: onCancelButtonClick
  }, t("cancel", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex flex-col-reverse sm:flex-row items-start justify-between pb-10 mt-0", !isMobile && "gap-[22px] md:!mt-4")
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("w-full relative sm:bg-white sm:min-w-[660px] sm:max-w-[660px] md:mx-auto", !isMobile && "border-none sm:rounded-xl sm:border sm:border-solid sm:border-[#EBF0F7] py-4 px-6", isOtpStep && "p-0")
  }, isMobile && !isOtpStep && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileCarInfoV2, {
    className: "mb-6",
    checkoutOrder: checkoutOrder,
    hideData: true,
    onClickInfoIcon: onInfoIconClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(WarrantySection, {
    checkoutOrder: checkoutOrder,
    onWarrantyChange: function onWarrantyChange(id) {
      return void (remote_actions === null || remote_actions === void 0 ? void 0 : remote_actions.fetch__getOrderDetailsByParams({
        warranty_id: id,
        city_id: String((userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id) || "")
      }));
    }
  }))), isOtpStep ? /*#__PURE__*/React.createElement(AmwalOTPStep, {
    userInfo: userInfo,
    onVerified: handleOtpVerified,
    post_id: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_id) || 0,
    financestep: 1
  }) : /*#__PURE__*/React.createElement(AmwalInfoComponent, {
    autosend: autosend,
    setIsOtpStep: setIsOtpStep,
    onFormUpdated: onFormUpdated,
    onFormCompleted: onFormCompleted
  })), /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-container",
    className: "w-full sm:min-w-[444px] sm:max-w-[444px]"
  }, isDesktop && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentInfo, {
    showWarrantyWidget: isDesktop && !isOtpStep,
    loading: fetch_loading || !checkoutOrder,
    checkoutOrder: checkoutOrder,
    className: "border-none md:rounded-xl md:border md:border-solid md:border-[#EBF0F7]",
    hideData: true,
    onClickInfoIcon: onInfoIconClick,
    orderType: "amwal",
    onWarrantySelected: function onWarrantySelected(id) {
      return void (remote_actions === null || remote_actions === void 0 ? void 0 : remote_actions.fetch__getOrderDetailsByParams({
        warranty_id: id,
        city_id: String((userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id) || "")
      }));
    }
  })))));
};
export default AmwalFormContent;